"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItemRightSection = exports.ListItemContentSection = exports.ListItemLeftSection = exports.ListItem = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("../css/list_item.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListItemLeftSection = function ListItemLeftSection(_ref) {
  var children = _ref.children;
  return _react.default.createElement("div", {
    className: "vn-list-item__content--left"
  }, children);
};

exports.ListItemLeftSection = ListItemLeftSection;
ListItemLeftSection.propTypes = {
  children: _propTypes.default.node.isRequired
};
ListItemLeftSection.displayName = 'ListItemLeftSection';
/*--------------------------------------------------*/

var ListItemContentSection = function ListItemContentSection(_ref2) {
  var children = _ref2.children;
  return _react.default.createElement("div", {
    className: "vn-list-item__content--middle"
  }, children);
};

exports.ListItemContentSection = ListItemContentSection;
ListItemContentSection.propTypes = {
  children: _propTypes.default.node.isRequired
};
ListItemContentSection.displayName = 'ListItemContentSection';
/*--------------------------------------------------*/

var ListItemRightSection = function ListItemRightSection(_ref3) {
  var children = _ref3.children;
  return _react.default.createElement("div", {
    className: "vn-list-item__content--right"
  }, children);
};

exports.ListItemRightSection = ListItemRightSection;
ListItemRightSection.propTypes = {
  children: _propTypes.default.node.isRequired
};
ListItemRightSection.displayName = 'ListItemRightSection';
/*--------------------------------------------------*/

var ListItem = function ListItem(_ref4) {
  var children = _ref4.children,
      className = _ref4.className;
  var listItemClasses = {
    'vn-list-item': true
  };

  if (className) {
    listItemClasses[className] = true;
  }

  return _react.default.createElement("div", {
    className: (0, _classnames.default)(listItemClasses)
  }, _react.default.createElement("div", {
    className: "vn-list-item__content"
  }, children));
};

exports.ListItem = ListItem;
ListItem.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.objectOf(ListItemLeftSection), _propTypes.default.objectOf(ListItemContentSection).isRequired, _propTypes.default.objectOf(ListItemRightSection), _propTypes.default.arrayOf(_propTypes.default.shape({
    ListItemLeftSection: ListItemLeftSection,
    ListItemContentSection: ListItemContentSection,
    ListItemRightSection: ListItemRightSection
  }))]).isRequired
};
ListItem.defaultProps = {
  className: undefined
};
ListItem.displayName = 'ListItem';
var _default = ListItem;
exports.default = _default;